import { Box, Chip, Divider, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import type { VersionChangeType } from 'utils/agreementVersioning'

export type ChangeTypeValue = VersionChangeType | 'io' | 'csa' | ''

interface SelectChangeTypeProps {
  changeType: ChangeTypeValue
  onChange: (event: any) => void
  nextVersion: string
  isSelected: boolean
  validationErrors: Record<string, any>
}

const changeTypeOptions: { value: VersionChangeType; label: string; description: string }[] = [
  { value: 'major', label: 'Add/Remove Products', description: 'New contract required' },
  { value: 'minor', label: 'Date Renewal & Budget Updates', description: 'Extend or change dates / update budget' },
  { value: 'patch', label: 'Budget/Pricing Change', description: 'Change pricing only' },
]

const newDealOptions: { value: 'io' | 'csa'; label: string; description: string }[] = [
  { value: 'io', label: 'Create New IO', description: 'Insertion Order' },
  { value: 'csa', label: 'Create New CSA', description: 'Creative Service Agreement' },
]

const SelectChangeType = ({
  changeType,
  onChange,
  nextVersion,
  isSelected,
  validationErrors,
}: SelectChangeTypeProps) => {
  const isVersionChange = changeType === 'major' || changeType === 'minor' || changeType === 'patch'

  return (
    <FormControl fullWidth disabled={!isSelected} error={isSelected && validationErrors?.changeType}>
      <InputLabel id="change-type-label">Change Type</InputLabel>
      <Select labelId="change-type-label" label="Change Type" value={changeType} onChange={onChange} required>
        {changeTypeOptions.map(opt => (
          <MenuItem key={opt.value} value={opt.value}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="subtitle1">{opt.label}</Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                — {opt.description}
              </Typography>
            </Box>
          </MenuItem>
        ))}
        <Divider />
        {newDealOptions.map(opt => (
          <MenuItem key={opt.value} value={opt.value}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="subtitle1">{opt.label}</Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                — {opt.description}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
      {isVersionChange && nextVersion && (
        <Box sx={{ mt: 0.5, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            Next version:
          </Typography>
          <Chip
            label={`v${nextVersion}`}
            size="small"
            color="primary"
            sx={{ fontFamily: 'monospace', fontWeight: 700, height: 20, fontSize: 11 }}
          />
        </Box>
      )}
    </FormControl>
  )
}

export default SelectChangeType
